"use client";
import { createContext } from "react";

export const IndicatorsContext = createContext();
